import { push_api } from "../../libs/api_builder";

const state = {
    can_close_modal : true,
    core_const : {},
    client: {
        id : 1
    },
    internal_api : {
        'token' : "",
        'pos_api' : "",
        "aggregator_api" : "",
    },
};

// actions
const actions = {

    LOAD_SERVICE({commit}) {
        api.get('/base').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('set_api', data.data);
            }
        }).catch(err => {
            console.log(err);
            commit('core_const', {});
        });
    },

    LOAD_MAIN_CONST ({commit}) {
        api.get('/api').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('core_const', data.message);
            }
        }).catch(err => {
            console.log(err);
            commit('core_const', {});
        });
    },

};

// mutations
const mutations = {
    core_const (state, data) {
        state.core_const = {...state.core_const, ...data}
    },

    set_api (state,data) {

        this.state.internal_api =  {...state.internal_api, ...data}

        window.pos_api = push_api('pos_api',data);
        window.agr_api = push_api('aggregator_api',data);
        window.delivery_api = push_api('delivery_api',data);
        window.notification_api = push_api('notification_api',data);
        window.media_api = push_api('media_api',data);
        window.export_api = push_api('export_api',data);
        window.review_api = push_api('review_api',data);

        EventBus.$emit('loaded_api');
    },
};



export default {
    namespaced: true,
    state,

    actions,
    mutations,
}
